function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { SplayTreeSet } from "splaytree-ts";
import { getBboxOverlap } from "./bbox.js";
import * as geomIn from "./geom-in.js";
import * as geomOut from "./geom-out.js";
import { precision } from "./precision.js";
import SweepEvent from "./sweep-event.js";
import SweepLine from "./sweep-line.js";
export var Operation = /*#__PURE__*/ function() {
    "use strict";
    function Operation() {
        _class_call_check(this, Operation);
        _define_property(this, "type", void 0);
        _define_property(this, "numMultiPolys", void 0);
    }
    _create_class(Operation, [
        {
            key: "run",
            value: function run(type, geom, moreGeoms) {
                operation.type = type;
                /* Convert inputs to MultiPoly objects */ var multipolys = [
                    new geomIn.MultiPolyIn(geom, true)
                ];
                for(var i = 0, iMax = moreGeoms.length; i < iMax; i++){
                    multipolys.push(new geomIn.MultiPolyIn(moreGeoms[i], false));
                }
                operation.numMultiPolys = multipolys.length;
                /* BBox optimization for difference operation
         * If the bbox of a multipolygon that's part of the clipping doesn't
         * intersect the bbox of the subject at all, we can just drop that
         * multiploygon. */ if (operation.type === "difference") {
                    // in place removal
                    var subject = multipolys[0];
                    var i1 = 1;
                    while(i1 < multipolys.length){
                        if (getBboxOverlap(multipolys[i1].bbox, subject.bbox) !== null) i1++;
                        else multipolys.splice(i1, 1);
                    }
                }
                /* BBox optimization for intersection operation
         * If we can find any pair of multipolygons whose bbox does not overlap,
         * then the result will be empty. */ if (operation.type === "intersection") {
                    // TODO: this is O(n^2) in number of polygons. By sorting the bboxes,
                    //       it could be optimized to O(n * ln(n))
                    for(var i2 = 0, iMax1 = multipolys.length; i2 < iMax1; i2++){
                        var mpA = multipolys[i2];
                        for(var j = i2 + 1, jMax = multipolys.length; j < jMax; j++){
                            if (getBboxOverlap(mpA.bbox, multipolys[j].bbox) === null) return [];
                        }
                    }
                }
                /* Put segment endpoints in a priority queue */ var queue = new SplayTreeSet(SweepEvent.compare);
                for(var i3 = 0, iMax2 = multipolys.length; i3 < iMax2; i3++){
                    var sweepEvents = multipolys[i3].getSweepEvents();
                    for(var j1 = 0, jMax1 = sweepEvents.length; j1 < jMax1; j1++){
                        queue.add(sweepEvents[j1]);
                    }
                }
                /* Pass the sweep line over those endpoints */ var sweepLine = new SweepLine(queue);
                var evt = null;
                if (queue.size != 0) {
                    evt = queue.first();
                    queue.delete(evt);
                }
                while(evt){
                    var newEvents = sweepLine.process(evt);
                    for(var i4 = 0, iMax3 = newEvents.length; i4 < iMax3; i4++){
                        var evt1 = newEvents[i4];
                        if (evt1.consumedBy === undefined) queue.add(evt1);
                    }
                    if (queue.size != 0) {
                        evt = queue.first();
                        queue.delete(evt);
                    } else {
                        evt = null;
                    }
                }
                // free some memory we don't need anymore
                precision.reset();
                /* Collect and compile segments we're keeping into a multipolygon */ var ringsOut = geomOut.RingOut.factory(sweepLine.segments);
                var result = new geomOut.MultiPolyOut(ringsOut);
                return result.getGeom();
            }
        }
    ]);
    return Operation;
}();
// singleton available by import
var operation = new Operation();
export default operation;
